import { render } from "./ReportInventoryBalances.vue?vue&type=template&id=0a0a9480&scoped=true"
import script from "./ReportInventoryBalances.vue?vue&type=script&lang=js"
export * from "./ReportInventoryBalances.vue?vue&type=script&lang=js"

import "./ReportInventoryBalances.vue?vue&type=style&index=0&id=0a0a9480&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0a9480"]])

export default __exports__